/**
 * REACT BITS PRO — FEATURES 7 (SEZNIK STOREFRONT EDITION)
 * Micro-interactions:
 * - Bidirectional scroll reveal (replays smoothly on every scroll up and down)
 * - Interactive like button counters on social reviews
 */
(function () {
  'use strict';

  function initFeatures7ScrollMotion() {
    const rows = document.querySelectorAll('.seznik-features7 .f7-row');
    if (!rows.length) return;

    if (!('IntersectionObserver' in window)) {
      rows.forEach(function (row) {
        row.classList.add('f7-in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('f7-in-view');
        } else {
          // Remove class when scrolling out of viewport so it animates in again on every scroll up or down
          entry.target.classList.remove('f7-in-view');
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    rows.forEach(function (row) {
      observer.observe(row);
    });
  }

  function initFeatures7Interactions() {
    const sections = document.querySelectorAll('.seznik-features7');
    if (!sections.length) return;

    sections.forEach(function (section) {
      // Like button interactivity on social reviews
      const likeBtns = section.querySelectorAll('.f7-like-btn');
      likeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const isLiked = this.classList.contains('is-liked');
          const countSpan = this.querySelector('span');
          let count = parseInt(countSpan.textContent.replace(/,/g, ''), 10) || 1420;

          if (isLiked) {
            this.classList.remove('is-liked');
            count -= 1;
          } else {
            this.classList.add('is-liked');
            count += 1;
          }
          countSpan.textContent = `❤️ ${count.toLocaleString()} likes`;
        });
      });
    });
  }

  function init() {
    initFeatures7ScrollMotion();
    initFeatures7Interactions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Live support for Shopify Theme Customizer
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('seznik-features7') || event.target.querySelector('.seznik-features7')) {
      init();
    }
  });
})();
